import { PluginContainerData, Media, Link } from "./common";
const baseImageData = {};
const ImageData = {
  fromJSON(object) {
    const message = { ...baseImageData };
    message.containerData = object.containerData !== void 0 && object.containerData !== null ? PluginContainerData.fromJSON(object.containerData) : void 0;
    message.image = object.image !== void 0 && object.image !== null ? Media.fromJSON(object.image) : void 0;
    message.link = object.link !== void 0 && object.link !== null ? Link.fromJSON(object.link) : void 0;
    message.disableExpand = object.disableExpand !== void 0 && object.disableExpand !== null ? Boolean(object.disableExpand) : void 0;
    message.altText = object.altText !== void 0 && object.altText !== null ? String(object.altText) : void 0;
    message.caption = object.caption !== void 0 && object.caption !== null ? String(object.caption) : void 0;
    message.disableDownload = object.disableDownload !== void 0 && object.disableDownload !== null ? Boolean(object.disableDownload) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.containerData !== void 0 && (obj.containerData = message.containerData ? PluginContainerData.toJSON(message.containerData) : void 0);
    message.image !== void 0 && (obj.image = message.image ? Media.toJSON(message.image) : void 0);
    message.link !== void 0 && (obj.link = message.link ? Link.toJSON(message.link) : void 0);
    message.disableExpand !== void 0 && (obj.disableExpand = message.disableExpand);
    message.altText !== void 0 && (obj.altText = message.altText);
    message.caption !== void 0 && (obj.caption = message.caption);
    message.disableDownload !== void 0 && (obj.disableDownload = message.disableDownload);
    return obj;
  }
};
export {
  ImageData
};
//# sourceMappingURL=plugin_image.js.map
